var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "DESIGN"
        ? _c("div", [_vm._m(0)])
        : _c(
            "div",
            {
              staticClass: "upload-container",
              class: {
                "hide-upload": _vm.maxNumber === _vm._value.length,
                "upload-container-has": _vm._value.length > 0,
              },
            },
            [
              !_vm.readerMode || _vm.perm === "E"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-con",
                          attrs: {
                            accept: "image/*",
                            action: "#",
                            limit: _vm.maxNumber,
                            "file-list": _vm._value,
                            "with-credentials": "",
                            "auto-upload": true,
                            multiple: _vm.maxNumber > 1,
                            data: _vm.uploadParams,
                            "list-type": "picture-card",
                            "before-upload": _vm.beforeUpload,
                            "http-request": _vm.uploadFile,
                            disabled: _vm.perm === "R",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "file",
                                fn: function ({ file }) {
                                  return _c(
                                    "div",
                                    { staticClass: "upload-file" },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: { src: file.url, alt: "" },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handlePictureCardPreview(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemove(file)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                },
                              },
                            ],
                            null,
                            false,
                            1832826232
                          ),
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            attrs: { slot: "default" },
                            slot: "default",
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "look-upload hide-upload" },
                    [
                      _vm._value.length > 0
                        ? _c(
                            "el-upload",
                            {
                              staticClass: "upload-con",
                              attrs: {
                                accept: "image/*",
                                action: "#",
                                limit: _vm.maxNumber,
                                "file-list": _vm._value,
                                "with-credentials": "",
                                "auto-upload": true,
                                multiple: _vm.maxNumber > 1,
                                data: _vm.uploadParams,
                                "list-type": "picture-card",
                                "before-upload": _vm.beforeUpload,
                                "http-request": _vm.uploadFile,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "file",
                                    fn: function ({ file }) {
                                      return _c(
                                        "div",
                                        { staticClass: "upload-file" },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "el-upload-list__item-thumbnail",
                                            attrs: { src: file.url, alt: "" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-actions",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "el-upload-list__item-preview",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handlePictureCardPreview(
                                                        file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-zoom-in",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    },
                                  },
                                ],
                                null,
                                false,
                                1515832032
                              ),
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "default" },
                                slot: "default",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ]
          ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "design" }, [
      _c("i", { staticClass: "el-icon-plus" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }